import { render, staticRenderFns } from "./ChangeSubject.vue?vue&type=template&id=f8c90cee&scoped=true"
import script from "./ChangeSubject.vue?vue&type=script&lang=js"
export * from "./ChangeSubject.vue?vue&type=script&lang=js"
import style0 from "./ChangeSubject.vue?vue&type=style&index=0&id=f8c90cee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c90cee",
  null
  
)

export default component.exports